import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import Layout from "../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Product from "../../actions/product";
import Admin from "../../components/auth/Admin";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableHead,
  TextField,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Notification from "../../components/customHelpers/Notification";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { formatNumber, getTimestamp } from "../../utils/utils";
const useStyles = makeStyles((theme) => ({
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const initialHeadCells = [
  { id: "name", label: "Product Name", isVisible: true },
  { id: "sku", label: "Sku", isVisible: true },
  { id: "store", label: "Store", isVisible: true },
  { id: "price", label: "Price", isVisible: true },
  { id: "quantity", label: "Quantity", isVisible: true },
  { id: "container", label: "Container", isVisible: true },
  { id: "totalPrice", label: "Total Price", isVisible: true },
  { id: "createdAt", label: "CreatedAt", isVisible: true },
];

const ContainerReport = () => {
  const classes = useStyles();
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const hiddenColumns = headCells.filter((cell) => !cell.isVisible);
  const { NotifyMessage, notify, setNotify } = Notify();
  const {
    viewAllProductsByContainerWithPages,
    viewAllProductsByContainer,
    viewTotalPriceByContainer,
  } = Product();

  const [containerProduct, setContainerProduct] = useState([]);
  const [temp, setTemp] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState("");
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const pageSizes = [15, 25, 50, 100];
  const [totalPrice, setTotalPrice] = useState({
    totalPrice: 0,
    isClick: true,
  });
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getProductsByContainerWithPages();
  }, [page, limit, searchQuery, selectedContainer]);
  useEffect(() => {
    getProductsByContainer();
  }, []);
  useEffect(() => {
    getTotalPrice();
  }, [selectedContainer]);
  const getTotalPrice = () => {
    viewTotalPriceByContainer(selectedContainer).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.totalPrice) {
        setTotalPrice({
          totalPrice: data.totalPrice || 0,
          isClick: true,
        });
      }
    });
  };
  const getProductsByContainerWithPages = () => {
    viewAllProductsByContainerWithPages(
      page,
      limit,
      searchQuery,
      selectedContainer
    ).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.product) {
        setValues({ ...values, loading: false });
        setContainerProduct(data.product);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };
  const getProductsByContainer = () => {
    viewAllProductsByContainer().then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.product) {
        setValues({ ...values, loading: false });
        setTemp(data.product);
      }
    });
  };

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(containerProduct, initialHeadCells, filterFn);
  const uniqueContainerNames = [...new Set(temp?.map((item) => item.name))];

  const generateReportFilename = (containerName, timestamp) => {
    return `${containerName}_Purchase_Inventory-report_${timestamp}`;
  };

  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const dataToExport = containerProduct.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.productList.product?.name;
          case "sku":
            return item.productList.product?.sku;
          case "store":
            return item.productList.store?.locationName;
          case "price":
            return item.productList.price;
          case "quantity":
            return item.quantity;
          case "container":
            return item.name;
          case "totalPrice":
            return item.productList.price * item.quantity;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    const totalPriceSum = containerProduct.reduce((sum, item) => {
      return sum + item.productList.price * item.quantity;
    }, 0);

    dataToExport.push([
      "Total Price",
      formatNumber(totalPriceSum.toFixed(2)),
      "",
      "",
      "",
      "",
      "",
      "",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      filteredHeadCells.map((cell) => cell.label),
      ...dataToExport,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const filename = generateReportFilename(selectedContainer, timestamp);
    saveAs(blob, `${filename}.xlsx`);
    handleClose();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const totalPriceSum = containerProduct.reduce((sum, item) => {
      return sum + item.productList.price * item.quantity;
    }, 0);

    const bodyData = containerProduct.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.productList.product?.name;
          case "sku":
            return item.productList.product?.sku;
          case "store":
            return item.productList.store?.locationName;
          case "price":
            return item.productList.price;
          case "quantity":
            return item.quantity;
          case "container":
            return item.name;
          case "totalPrice":
            return formatNumber(item.productList.price * item.quantity);
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    doc.autoTable({
      head: [filteredHeadCells.map((cell) => cell.label)],
      body: bodyData,
      styles: { fontSize: 10 },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });

    const finalY = doc.lastAutoTable.finalY || 10;
    doc.text(
      `Total Price: ${formatNumber(totalPriceSum.toFixed(2))}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 10,
      { align: "right" }
    );

    const timestamp = getTimestamp();
    const filename = generateReportFilename(selectedContainer, timestamp);
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const visibleColumns = headCells.filter((cell) => cell.isVisible);

  const handleColumnToggle = (id) => {
    const updatedHeadCells = headCells.map((cell) =>
      cell.id === id ? { ...cell, isVisible: !cell.isVisible } : cell
    );
    setHeadCells(updatedHeadCells);
  };

  const clearFilters = () => {
    setPage(1);
    setLimit(15);
    setSelectedContainer("");
  };

  const handleContainerChange = (e) => {
    const selectedName = e.target.value;
    setPage(1);
    setSelectedContainer(selectedName);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Inventory Report (Purchase order)
          </Typography>

          <Box display="flex" justifyContent="start" gap={2}>
            <TextField
              id="outlined-select-currency"
              select
              label="Filter By Container"
              sx={{ marginTop: "8px", width: "20%" }}
              value={selectedContainer}
              onChange={handleContainerChange}
            >
              {uniqueContainerNames.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <Box display="flex" justifyContent="end" gap={2} m={1}>
              <Box>
                <Button
                  variant="contained"
                  onClick={clearFilters}
                  endIcon={<CancelIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)",
                    },
                  }}
                >
                  Clear
                </Button>
              </Box>
              <Box sx={{ width: "27%" }}>
                <Button
                  variant="contained"
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  startIcon={<DownloadIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)",
                    },
                  }}
                >
                  Export
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem onClick={exportToPDF}>PDF</MenuItem>
                  <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                </Menu>
              </Box>
            </Box>
          </Box>

          <Grid container spacing={2}>
            <Grid
              item
              xs={hiddenColumns.length > 0 ? 10 : 12}
              className="card__body"
            >
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {visibleColumns.map((headCell) => (
                            <TableCell
                              className={
                                headCell.isVisible
                                  ? "table-cell-visible"
                                  : "table-cell-hidden"
                              }
                              key={headCell.id}
                              style={{
                                backgroundColor: "rgba(244,151,3,.8)",
                                color: "rgb(20,61,89)",
                                width: headCell.isVisible ? "auto" : "0",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Typography variant="subtitle1" noWrap>
                                  {headCell.label}
                                </Typography>
                                <Checkbox
                                  checked={headCell.isVisible}
                                  onChange={() =>
                                    handleColumnToggle(headCell.id)
                                  }
                                  icon={<CheckBoxOutlineBlankIcon />}
                                  checkedIcon={<CancelIcon />}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      backgroundColor: "transparent !important",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {recordsAfterSortingAndFiltering().length > 0 ? (
                          recordsAfterSortingAndFiltering().map((item) => (
                            <TableRow key={item.id}>
                              {visibleColumns.map((headCell) => (
                                <TableCell key={headCell.id}>
                                  {headCell.id === "name"
                                    ? item.productList?.product?.name
                                    : headCell.id === "sku"
                                    ? item.productList?.product?.sku
                                    : headCell.id === "store"
                                    ? item.productList?.store?.locationName
                                    : headCell.id === "price"
                                    ? item.productList?.price
                                    : headCell.id === "quantity"
                                    ? item.quantity
                                    : headCell.id === "container"
                                    ? item.name
                                    : headCell.id === "totalPrice"
                                    ? formatNumber(
                                        parseFloat(
                                          item.productList?.price?.replace(
                                            /[, ]/g,
                                            ""
                                          )
                                        ) *
                                          (parseInt(
                                            item.quantity
                                              .toString()
                                              .replace(/[, ]/g, ""),
                                            10
                                          ) || 0)
                                      )
                                    : headCell.id === "createdAt"
                                    ? new Date(item.createdAt).toLocaleString()
                                    : null}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <Norecords col={6} />
                        )}
                      </TableBody>
                    </Table>
                  </TblContainer>
                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {containerProduct.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                      />
                    )}
                  </Box>{" "}
                  <Box display="flex" justifyContent="end" gap={2} m={1} p={1}>
                    <div
                      style={{
                        marginRight: "35px",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      Total Price: {formatNumber(totalPrice.totalPrice)}
                    </div>
                  </Box>
                </Paper>
              )}
            </Grid>
            {hiddenColumns.length > 0 && (
              <Grid item xs={2} className="card__body" sx={{ marginLeft: 10 }}>
                <Typography variant="h6">Hidden Columns</Typography>
                <FormGroup sx={{ marginTop: 0 }}>
                  {hiddenColumns.map((headCell, index) => (
                    <FormControlLabel
                      key={headCell.id}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              backgroundColor: "transparent",
                            },
                          }}
                          onChange={() => handleColumnToggle(headCell.id)}
                        />
                      }
                      label={headCell.label}
                      sx={{
                        marginBottom:
                          index === hiddenColumns.length - 1 ? 0 : 1,
                        "& .MuiFormControlLabel-label": {
                          marginTop: 0,
                        },
                      }}
                    />
                  ))}
                </FormGroup>
              </Grid>
            )}
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default ContainerReport;
